import pdfMake from 'pdfmake/build/pdfmake';
import html2canvas from 'html2canvas';
import GloboAves_logo from '../../../../assets/GloboAves.jpeg';
import everlink_logo from '../../../../assets/everlink-logo.png';
import DMLogistica_logo from '../../../../assets/DM_Logistica.png';

function MakeFarmsPDF(reportData, temp_int, humid, co2, portAndAc, initialDate, finalDate, companyName) {

  const chartElement1 = document.getElementById('canvaIDtemperatureFarm');
  const chartElement2 = document.getElementById('canvaIDhumidityFarm');
  const chartElement3 = document.getElementById('canvaIDco2Farm');
  const chartElement4 = document.getElementById('canvaIDportAndAcFarm');

  generatePDF(reportData, temp_int, humid, co2, chartElement1, chartElement2, chartElement3, chartElement4, initialDate, finalDate, companyName);
}

function convertImageToBase64(imagePath) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = imagePath;
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;

      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);

      const dataURL = canvas.toDataURL('image/png');
      resolve(dataURL);
    };
    img.onerror = (error) => {
      reject(error);
    };

  });
}

async function createHeader(reportData, initialDate, finalDate, companyName) {

  const imagePath = companyName === "DM LOGISTICA E TRANSPORTE LTDA" ? DMLogistica_logo : companyName === "ManagementCompany" ? everlink_logo : GloboAves_logo;
  let imageLogo;
  await convertImageToBase64(imagePath)
    .then((base64String) => {
      imageLogo = base64String;
    })
    .catch((error) => {
      console.error(error);
    });
  try {
    const header = {
      margin: [15, 10, 15, 0],
      columns: [
        {
          stack: [
            {
              table: {
                headerRows: 1,
                widths: [100, '*', 100],
                body: [
                  [
                    { image: imageLogo, width: companyName === "DM LOGISTICA E TRANSPORTE LTDA" ? 65 : companyName === "ManagementCompany" ? 80 : 75, height: companyName === "DM LOGISTICA E TRANSPORTE LTDA" ? 20 : companyName === "ManagementCompany" ? 20 : 25, margin: [12, companyName === "DM LOGISTICA E TRANSPORTE LTDA" ? 6 : companyName === "ManagementCompany" ? 8 : 3, 0, 0] },
                    {
                      text: [
                        { text: 'Gestão de Ambientes\n', bold: true, alignment: 'center' },
                        { text: `Sala: ${reportData.vehiclePlate} - Período: ${initialDate} até ${finalDate}`, fontSize: 8, alignment: 'center' },
                      ],
                    },
                    { image: everlink_logo, width: 80, height: 20, margin: [8, 5, 0, 0] },
                  ],
                ],
              },
            },
          ],
        },
      ],
    };
    return header;
  } catch (error) {
    console.error(error);
    throw error;
  }
}


async function generatePDF(reportData, temp_int, humid, co2, chartElement1, chartElement2, chartElement3, chartElement4, initialDate, finalDate, companyName) {

  const listInt1 = temp_int.sensor1Values;
  const listInt2 = temp_int.sensor2Values;
  const listInt3 = temp_int.sensor3Values;
  const listHumd1 = humid.sensor1Values;
  const listHumd2 = humid.sensor2Values;
  const listCO1 = co2.sensor1Values;


  return new Promise((resolve) => {

    const canvas = document.createElement('canvas');
    const chartRect = chartElement2.getBoundingClientRect();

    canvas.width = chartRect.width;
    canvas.height = chartRect.height;

    const c1 = html2canvas(chartElement1);
    const c2 = html2canvas(chartElement2);
    const c3 = html2canvas(chartElement3);
    const c4 = html2canvas(chartElement4);

    var minReduce = function (a, b) { return (isNaN(b) || b > a) ? a : b }
    var maxReduce = function (a, b) { return (isNaN(b) || b < a) ? a : b }
    const maxInt1 = listInt1.reduce(maxReduce, Number.MIN_VALUE);
    const minInt1 = listInt1.reduce(minReduce, Number.MAX_VALUE);
    const maxInt2 = listInt2.reduce(maxReduce, Number.MIN_VALUE);
    const minInt2 = listInt2.reduce(minReduce, Number.MAX_VALUE);
    const maxInt3 = listInt3.reduce(maxReduce, Number.MIN_VALUE);
    const minInt3 = listInt3.reduce(minReduce, Number.MAX_VALUE);
    const maxInt4 = listHumd1.reduce(maxReduce, Number.MIN_VALUE);
    const minInt4 = listHumd1.reduce(minReduce, Number.MAX_VALUE);
    const maxInt5 = listHumd2.reduce(maxReduce, Number.MIN_VALUE);
    const minInt5 = listHumd2.reduce(minReduce, Number.MAX_VALUE);
    const maxInt6 = listCO1.reduce(maxReduce, Number.MIN_VALUE);
    const minInt6 = listCO1.reduce(minReduce, Number.MAX_VALUE);


    var filteredList = listInt1.filter(value => !isNaN(value));
    const sumTP = filteredList.reduce((acc, cur) => acc + cur, 0);
    const averageTempP = sumTP / filteredList.length;

    filteredList = listInt2.filter(value => !isNaN(value));
    const sumTS = filteredList.reduce((acc, cur) => acc + cur, 0);
    const averageTempS = sumTS / filteredList.length;

    filteredList = listInt3.filter(value => !isNaN(value));
    const sumTE = filteredList.reduce((acc, cur) => acc + cur, 0);
    const averageTempE = sumTE / filteredList.length;

    filteredList = listHumd1.filter(value => !isNaN(value));
    const sumUP = filteredList.reduce((acc, cur) => acc + cur, 0);
    const averageUp = sumUP / filteredList.length;

    filteredList = listHumd2.filter(value => !isNaN(value));
    const sumUS = filteredList.reduce((acc, cur) => acc + cur, 0);
    const averageUs = sumUS / filteredList.length;

    filteredList = listCO1.filter(value => !isNaN(value));
    const sumCOP = filteredList.reduce((acc, cur) => acc + cur, 0);
    const averageCOP = sumCOP / filteredList.length;

    Promise.all([c1, c2, c3, c4]).then(async ([c1, c2, c3, c4]) => {
      const docDefinition = {
        pageSize: 'A4',
        pageMargins: [15, 50, 15, 40],
        header: await createHeader(reportData, initialDate, finalDate, companyName),
        content: [
          { image: c1.toDataURL('image/png'), width: 560, height: 170, absolutePosition: { x: 10, y: 45 }, },
          { image: c2.toDataURL('image/png'), width: 560, height: 170, absolutePosition: { x: 10, y: 235 }, },
          { image: c3.toDataURL('image/png'), width: 560, height: 170, absolutePosition: { x: 10, y: 435 }, },
          { image: c4.toDataURL('image/png'), width: 560, height: 170, absolutePosition: { x: 10, y: 615 }, },
          { text: '', pageBreak: 'before' },
          {
            table: {
              widths: [555],
              heights: [380],
              body: [
                [
                  {
                    margin: [0, 30],
                    table: {
                      widths: ['*', '*'],
                      heights: [25, 25, 25, 25, 25, 25],
                      body: [
                        [
                          {
                            text: 'QUANTIDADE DE ALARMES', bold: true, fontSize: 12, alignment: 'center', relativePosition: { y: 5 }
                          },
                          {
                            text: reportData.mostQtdy.toString(), bold: true, fontSize: 12, alignment: 'center', relativePosition: { y: 5 }
                          }
                        ],
                      ],

                    },
                    border: [true, true, true, false],
                  },
                ],
                [
                  {
                    margin: [0, -280],
                    table: {
                      widths: ['*', '*', '*', '*'],
                      heights: [25, 25, 25, 25, 25, 25, 25],
                      body: [
                        [
                          {
                            text: '', border: [false, false, false, false],
                          },
                          {
                            text: 'Mínimo', fontSize: 18, alignment: 'center', bold: true
                          },
                          {
                            text: 'Média', fontSize: 18, alignment: 'center', bold: true
                          },
                          {
                            text: 'Máximo', fontSize: 18, alignment: 'center', bold: true
                          }
                        ],
                        [
                          {
                            stack: [
                              { text: 'Temp P  ', fontSize: 14, alignment: 'center', bold: true },
                              { text: '1', alignment: 'center', fontSize: 8, color: 'black', relativePosition: { x: 28, y: -15 }, bold: true },
                            ],
                            fontSize: 14
                          },
                          {
                            text: minInt1.toFixed(2).toString(), alignment: 'center', fontSize: 14, relativePosition: { y: 5 }
                          },
                          {
                            text: averageTempP.toFixed(2).toString(), alignment: 'center', fontSize: 14, relativePosition: { y: 5 }
                          },
                          {
                            text: maxInt1.toFixed(2).toString(), alignment: 'center', fontSize: 14, relativePosition: { y: 5 }
                          },
                        ],
                        [
                          {
                            stack: [
                              { text: 'Temp S  ', alignment: 'center', fontSize: 14, bold: true },
                              { text: '1', alignment: 'center', fontSize: 8, color: 'black', relativePosition: { x: 28, y: -15 }, bold: true },
                            ],
                            fontSize: 14
                          },
                          {
                            text: minInt2.toFixed(2).toString(), alignment: 'center', fontSize: 14, relativePosition: { y: 5 }
                          },
                          {
                            text: averageTempS.toFixed(2).toString(), alignment: 'center', fontSize: 14, relativePosition: { y: 5 }
                          },
                          {
                            text: maxInt2.toFixed(2).toString(), alignment: 'center', fontSize: 14, relativePosition: { y: 5 }
                          }
                        ],
                        [
                          {
                            stack: [
                              { text: 'Temp E  ', alignment: 'center', fontSize: 14, bold: true },
                              { text: '1', alignment: 'center', fontSize: 8, color: 'black', relativePosition: { x: 28, y: -15 }, bold: true },
                            ],
                            fontSize: 14
                          },
                          {
                            text: minInt3.toFixed(2).toString(), alignment: 'center', fontSize: 14, relativePosition: { y: 5 }
                          },
                          {
                            text: averageTempE.toFixed(2).toString(), alignment: 'center', fontSize: 14, relativePosition: { y: 5 }
                          },
                          {
                            text: maxInt3.toFixed(2).toString(), alignment: 'center', fontSize: 14, relativePosition: { y: 5 }
                          }
                        ],
                        [
                          {
                            stack: [
                              { text: 'Umid P  ', alignment: 'center', fontSize: 14, bold: true },
                              { text: '2', alignment: 'center', fontSize: 8, color: 'black', relativePosition: { x: 28, y: -15 }, bold: true },
                            ],
                            fontSize: 14
                          },
                          {
                            text: minInt4.toFixed(2).toString(), alignment: 'center', fontSize: 14, relativePosition: { y: 5 }
                          },
                          {
                            text: averageUp.toFixed(2).toString(), alignment: 'center', fontSize: 14, relativePosition: { y: 5 }
                          },
                          {
                            text: maxInt4.toFixed(2).toString(), alignment: 'center', fontSize: 14, relativePosition: { y: 5 }
                          }
                        ],
                        [
                          {
                            stack: [
                              { text: 'Umid S  ', alignment: 'center', fontSize: 14, bold: true },
                              { text: '2', alignment: 'center', fontSize: 8, color: 'blakc', relativePosition: { x: 28, y: -15 }, bold: true },
                            ],
                            fontSize: 14
                          },
                          {
                            text: minInt5.toFixed(2).toString(), alignment: 'center', fontSize: 14, relativePosition: { y: 5 }
                          },
                          {
                            text: averageUs.toFixed(2).toString(), alignment: 'center', fontSize: 14, relativePosition: { y: 5 }
                          },
                          {
                            text: maxInt5.toFixed(2).toString(), alignment: 'center', fontSize: 14, relativePosition: { y: 5 }
                          }
                        ],
                        [
                          {
                            stack: [
                              { text: 'CO2 P  ', alignment: 'center', fontSize: 14, bold: true },
                              { text: '3', alignment: 'center', fontSize: 8, color: 'black', relativePosition: { x: 28, y: -15 }, bold: true },
                            ],
                            fontSize: 14
                          },
                          {
                            text: minInt6.toFixed(2).toString(), alignment: 'center', fontSize: 14, relativePosition: { y: 5 }
                          },
                          {
                            text: averageCOP.toFixed(2).toString(), alignment: 'center', fontSize: 14, relativePosition: { y: 5 }
                          },
                          {
                            text: maxInt6.toFixed(2).toString(), alignment: 'center', fontSize: 14, relativePosition: { y: 5 }
                          }
                        ],
                      ],

                    },
                    border: [true, false, true, false],
                  },
                ],
                [
                  {
                    margin: [0, -70],
                    table: {
                      widths: ['*', '*', '*'],
                      body: [
                        [
                          {
                            border: [false, false, false, false],
                            margin: [30, 5, 0, 5],
                            stack: [
                              { text: '1 ', fontSize: 7, relativePosition: { y: -2 } },
                              { text: 'Expresso em ºC', alignment: 'center', fontSize: 10, relativePosition: { x: -34 } }
                            ],
                            color: 'black',
                          },
                          {
                            border: [false, false, false, false],
                            margin: [50, 5, 0, 5],
                            stack: [
                              { text: '2 ', fontSize: 7, relativePosition: { y: -2 } },
                              { text: 'Expresso em %', alignment: 'center', fontSize: 10, relativePosition: { x: -25 } }
                            ],
                            color: 'black',
                          },
                          {
                            border: [false, false, false, false],
                            margin: [50, 5, 0, 5],
                            stack: [
                              { text: '3 ', fontSize: 7, relativePosition: { y: -2 } },
                              { text: 'Expresso em PPM', alignment: 'center', fontSize: 10, relativePosition: { x: -18 } }
                            ],

                            color: 'black',
                          },
                        ],
                      ],

                    },
                    border: [true, false, true, false],
                  },
                ],
                [
                  {
                    table: {
                      widths: ['*', '*'],
                      heights: [240, 240, 240, 240, 240, 240],
                      body: [
                        [

                        ],
                      ],

                    },
                    border: [true, false, true, true],
                  },
                ],

              ],
            },
          },
        ],
        footer: function (currentPage, pageCount) {
          return {
            text: `Página ${currentPage.toString()}/${pageCount.toString()}`,
            alignment: 'right',
            fontSize: 10,
            color: 'black',
            margin: [50, 0],
          };

        }

      };
      pdfMake.createPdf(docDefinition).download(reportData.vehiclePlate + '-' + initialDate, () => {
        resolve();
      });
    });
  });
}

export default MakeFarmsPDF;













